module.exports = __webpack_public_path__ + "static/media/recoveryRegistrationStep.914d18f2.md";